import React from 'react';
import './AboutUs.css'; // reuse styling for layout and footer
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import heroImg from '../assets/about/hero-1.jpg';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';


const mandatoryDocs = [
  { label: 'Affiliation/Extension Letter', file: '/pdfs/affiliation-letter.pdf' },
  { label: 'School Management Committee', file: '/pdfs/school-management-committee.pdf' },
  { label: 'Infrastructure Details', file: '/pdfs/infrastructure-details.pdf' },
  { label: 'Recognition Certificate', file: '/pdfs/recognition-certificate.pdf' },
  { label: 'No Objection Certificate (NOC)', file: '/pdfs/noc-certificate.pdf' },
  { label: 'Fire Safety Certificate', file: '/pdfs/fire-safety-certificate.pdf' },
  { label: 'Building Safety Certificate', file: '/pdfs/building-safety-certificate.pdf' },
  { label: 'DEO Certificate of Land', file: '/pdfs/deo-land-certificate.pdf' },
  { label: 'List of Teaching Staff', file: '/pdfs/teaching-staff.pdf' },
  { label: 'School Fee Structure', file: '/pdfs/fee-structure.pdf' },
];

const MandatoryDisclosure = () => {
  return (
    <div className="about-page">
     
       <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   

     
    
    
 <section className="about-hero">
        <img src={heroImg} alt="Universal Academy Campus" />
        <div className="hero-text">
          <h1>Mandatory Disclosure</h1>
		   <p>we provide open access to all essential documentation.</p>
        </div>
      </section>
      {/* Mandatory Disclosure Section */}
      <section className="about-intro">
        <h2>Mandatory Disclosure Documents</h2>
        <p>
          In accordance with CBSE and regulatory body requirements, we provide open access to all essential documentation.
        </p>
      </section>

      <section style={{ padding: '20px 0', backgroundColor: '#f9f9f9' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 20px', textAlign: 'center' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            {mandatoryDocs.map((doc, index) => (
              <a
                key={index}
                href={doc.file}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#125303',
                  color: '#fff',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  minWidth: '260px',
                }}
              >
                📄 {doc.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
     <Footer /> 
    </div>
  );
};

export default MandatoryDisclosure;
